import React, { useEffect, useState } from 'react';
import { getSitesTotals } from '../../Utils/invoiceTotals';
import { formatCurrency } from "../../Utils/formatCurrency";

const CartList = ({ modules, invoice, siteOrdered, waLocalTaxes }) => {


    let { sitesTax, sitesSum, sitesLocalTax } = getSitesTotals(invoice, modules, siteOrdered);
    // const hasTax = invoice.url_key === 'wacis' && waLocalTaxes && waLocalTaxes.length > 0;
    // console.log('hasTax', hasTax, invoice.url_key, waLocalTaxes);
    const fieldClasses = {
        product: 'col col-lg-4 col-md-6 col-sm-6 col-xs-12',
        yearlyLicense: 'col col-lg-3 col-md-2 col-sm-4 col-xs-4 d-none d-sm-block text-right', // hidden only on small
        enrollment: 'col col-lg-2 col-md-2 col-sm-4 col-xs-4 d-none d-sm-block text-center', // hidden only on small
        qty: 'col col-lg-1 col-md-1 col-sm-2 d-none d-sm-block text-right',
        total: 'col col-lg-2 col-md-2 d-sm-none d-md-block text-right'
    }
    const uniqueItems = (arr, property) => {
        return [...new Set(arr.map(item => item[property]))];
    }


    // const [counties, setCounties] = useState(() => {
    //     const storedData = localStorage.getItem('localCounties');
    //     return storedData ? JSON.parse(storedData) : [];
    // });

    let allCounties = [];
    allCounties = (invoice.url_key === 'wacis' && waLocalTaxes && waLocalTaxes.length > 0) ? uniqueItems(waLocalTaxes, 'County') : [];
    // console.log('allCounties', allCounties);
    // setCounties(allCounties);

    const [locations, setLocations] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState('');
    const [selectedCounty, setSelectedCounty] = useState('');


    /**handle county select event */
    const handleCountyChange = (county) => {
        setLocations([]);
        setSelectedLocation('0000');
        setSelectedCounty(county);
        invoice.local_tax_pct = 0;

        invoice.local_tax_county = county;
        invoice.local_tax_location = '';
        const locations = waLocalTaxes.filter((item) => item.County === county);
        invoice.tax_pct = parseFloat(waLocalTaxes[0].State_rate);
        if (locations && locations.length > 0) {
            setLocations(locations);
        }
        else {
            setLocations([]);
        }
    };



    const handleLocationChange = (location) => {

        setSelectedLocation(location);

        const selectedLocation = locations.find((item) => item.Location_Code === parseInt(location));

        if (selectedLocation && selectedLocation !== undefined) {
            // invoice.tax_pct = parseFloat(selectedLocation.Combined_sales_tax);
            invoice.local_tax_pct = parseFloat(selectedLocation.Local_rate);
            invoice.local_tax_location = selectedLocation.Location + ' (CODE:' + selectedLocation.Location_Code + ')';
            invoice.local_tax_county = selectedCounty;
        }
        else {
            invoice.local_tax_pct = 0.0;
            invoice.local_tax_location = '';
            invoice.local_tax_county = '';
        }
    };


    useEffect(() => {
        // setCounties(allCounties);
        // localStorage.setItem('localCounties', JSON.stringify(counties));
        localStorage.setItem('selectedCounty', JSON.stringify(selectedCounty));

    });

    /**for display  */
    const subTotal = (siteOrder) => {
        if (!siteOrder || !siteOrder.addOns) return 0;
        const addOnTotal = siteOrder.addOns.reduce((memo, item) => {
            return memo + item.price;
        }, 0);
        if (siteOrder.appType === 'High' || siteOrder.appType === 'Junior') {
            if (siteOrder.price < 300) {
                siteOrder.price = 300;
                siteOrder.is_variable_price = false;
                return addOnTotal + 300;
            }
            return addOnTotal + siteOrder.price;
        }
        return addOnTotal + siteOrder.price;
    }



    return (
        <div className="card p-0 invoice-card" style={{ fontSize: 'smaller' }}>
            <div className="card-header">
                <div className="row" style={{ fontWeight: '700' }}>

                    <div className={fieldClasses.product}><span className="card-title">Product</span></div>
                    <div className={fieldClasses.yearlyLicense}><span className="card-title">Yearly License</span></div>
                    <div className={fieldClasses.enrollment}><span className="card-title">Enrollments/Users</span></div>
                    <div className={fieldClasses.qty}><span className="card-title">Qty</span></div>
                    <div className={fieldClasses.total}><span className="card-title">Total</span></div>
                </div>
            </div>
            <div className="card-body">
                {siteOrdered && siteOrdered.map((site, index) => (
                    <React.Fragment key={`module-${index}-key`}>
                        {index > 0 && <hr />}
                        <div className="row">
                            <div className={'font-weight-bold ' + fieldClasses.product + (index % 2 ? ' pt-2' : '')}>{site.schoolName}</div>
                        </div>
                        <div className="row">
                            <div className={'font-weight-bold ' + fieldClasses.product + (index % 2 ? ' pt-2' : '')}>{site.service_name}</div>
                            <div className={fieldClasses.yearlyLicense}>
                                {(site.price > 0 && (!site.is_variable_price || (
                                    site.appType === 'Individual')
                                )) ? (
                                    formatCurrency(site.price)
                                ) :
                                    <>

                                        {(site.appType !== 'optional' && ((site.appType === 'High' || site.appType === 'Junior') && site.price <= 300)) ?
                                            (<span>{formatCurrency(300)}</span>)
                                            :
                                            (site.appType !== 'optional' && site.price_per_person > 0) &&
                                            <span>{formatCurrency(site.price_per_person)}/student</span>
                                        }

                                    </>
                                }
                            </div>
                            <div className={fieldClasses.enrollment}>
                                {site.enrollment > 0 &&
                                    <span>{site.enrollment}</span>
                                }
                            </div>
                            <div className={fieldClasses.qty}>
                                {site.price > 0 ? (
                                    <>
                                        1
                                    </>
                                ) : (
                                    <span> </span>
                                )}

                            </div>
                            <div className={fieldClasses.total}>
                                {(site.price > 0 && (!site.is_variable_price || site.appType === 'Individual')) ? (
                                    <>
                                        {formatCurrency(site.price)}
                                    </>
                                ) :
                                    <>
                                        {(site.appType !== 'optional' && ((site.appType === 'High' || site.appType === 'Junior') && site.price <= 300)) ?
                                            (<span>{formatCurrency(300)}</span>)
                                            :
                                            (site.appType !== 'optional' && site.price_per_person > 0) &&
                                            <span>{formatCurrency(site.price_per_person * site.enrollment)}</span>
                                        }
                                    </>
                                }

                            </div>
                        </div>
                        {site && site.addOns && site.addOns.map((service, serviceIndex) => (
                            <div className="row" key={`service-${serviceIndex}-key`}>
                                <div className={fieldClasses.product}>- {service.service_name}</div>
                                <div className={fieldClasses.yearlyLicense}>
                                    {formatCurrency(service.price)}
                                </div>
                                <div className={fieldClasses.enrollment}>

                                </div>
                                <div className={fieldClasses.qty}>1</div>
                                <div className={fieldClasses.total}>
                                    {formatCurrency(service.price)}
                                </div>
                            </div>
                        ))
                        }
                        {site &&
                            <div className="row" key={`service-${site.siteId}-key`}>
                                <div className='col text-right font-weight-bold'>
                                    Subtotal:
                                </div>
                                <div className='col text-right font-weight-bold'>
                                    {formatCurrency(subTotal(site))}
                                </div>
                            </div>
                        }
                    </React.Fragment>
                ))}
            </div>
            <div className="card-footer" style={{ fontWeight: '700' }}>
                <div className="row">
                    <div className="col-sm-12 col-md-6">
                        {allCounties.length > 0 &&
                            <>
                                <div className="row">
                                    <p className="text-primary">If your city or county has local sales tax, select county and location.</p>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 col-md-12 col-lg-6">
                                        <label htmlFor="selectedCountyId">Select a county</label>
                                        <select id="selectedCountyId" className="form-control form-control-sm" onChange={(e) => handleCountyChange(e.target.value)}>
                                            <option value="none">Select a county</option>
                                            {
                                                allCounties.map((county, index) =>
                                                    <option key={index} value={county}>{county}</option>)
                                            }
                                        </select>

                                    </div>
                                    {(locations.length > 0) &&
                                        <div className="col-sm-12 col-md-12 col-lg-6">
                                            <label htmlFor="selectedLocation">Select a location({locations.length} locations)</label>
                                            <select value={selectedLocation} className="form-control form-control-sm" onChange={(e) => handleLocationChange(e.target.value)}>
                                                <option value="0000">Select a location </option>
                                                {
                                                    locations.map((location, ind) =>
                                                        <option key={ind} value={location.Location_Code} >{location.Location} ({(location.Local_rate * 100).toFixed(2)}%)</option>)
                                                }
                                            </select>


                                        </div>
                                    }
                                </div>
                            </>
                        }

                    </div>
                    <div className="col-sm-12 col-md-6">
                        <div className="row">
                            <div style={{ height: '1em' }}></div>
                        </div>
                        <div className="row">
                            <div className="col-sm-0 col-md-2"></div>
                            <div className="col-6 col-sm-6 col-md-4">Years</div>
                            <div className="col-6 col-sm-6 col-md-6 text-right">x {invoice && invoice.license_term}</div>
                        </div>
                        {invoice.url_key === 'wacis' &&
                            <div className="row">
                                <div className="col-sm-0 col-md-2"></div>
                                <div className="col-6 col-sm-6 col-md-5">
                                    State Tax {invoice.tax_pct ? <span>({(invoice.tax_pct * 100).toFixed(2)}%)</span> : ''}</div>
                                <div className="col-6 col-sm-6 col-md-5 text-right">
                                    {formatCurrency(sitesTax)}
                                </div>
                            </div>
                        }
                        {invoice.url_key !== 'wacis' &&
                            <div className="row">
                                <div className="col-sm-0 col-md-2"></div>
                                <div className="col-6 col-sm-6 col-md-5">
                                    Tax {invoice.tax_pct ? <span>({(invoice.tax_pct * 100).toFixed(2)}%)</span> : ''}</div>
                                <div className="col-6 col-sm-6 col-md-5 text-right">
                                    {formatCurrency(sitesTax)}
                                </div>
                            </div>
                        }
                        {/* local tax if avail. */}
                        {invoice.local_tax_pct > 0.0 && invoice.url_key === 'wacis' &&
                            (

                                <div className="row">

                                    <div className="col-sm-0 col-md-2"></div>
                                    <div className="col-6 col-sm-6 col-md-5">Local Tax <span>({(invoice.local_tax_pct * 100).toFixed(2)}%)</span> </div>
                                    <div className="col-6 col-sm-6 col-md-5 text-right">
                                        {formatCurrency(sitesLocalTax)}
                                    </div>
                                </div>
                            )
                        }

                        <div className="row">
                            <div className="col-sm-0 col-md-2"></div>
                            <div className="col-6 col-sm-6 col-md-4">Total</div>
                            <div className="col-6 col-sm-6 col-md-6 text-right">

                                {formatCurrency(sitesSum)}
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    )
}


export { CartList };